const MATERIAL_NAMESPACES = ["/material", "/mobile/material"] as const;

export default MATERIAL_NAMESPACES;
